export default "__VITE_ASSET__DRaHFPsr__"